var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18187 6.36288V11C9.18187 12.66 10.4402 14 11.999 14C13.2706 14 14.3423 13.1083 14.694 11.8786L9.18187 6.36288ZM16.1495 13.335C15.3595 14.9173 13.7979 16 11.999 16C9.67956 16 7.75453 14.2 7.36952 11.85C7.2944 11.36 6.90939 11 6.44926 11C5.87645 11 5.42571 11.54 5.51022 12.14C5.97035 15.14 8.22405 17.49 11.06 17.92V20C11.06 20.55 11.4825 21 11.999 21C12.5155 21 12.938 20.55 12.938 20V17.92C14.8803 17.6255 16.5494 16.4305 17.5563 14.7428L16.1495 13.335ZM18.3708 12.7369L16.9097 11.2749C17.0771 11.1034 17.3021 11 17.5487 11C18.1216 11 18.5817 11.54 18.4878 12.14C18.4568 12.342 18.4177 12.5411 18.3708 12.7369ZM14.8161 9.17988L9.42244 3.78268C9.85986 2.73131 10.8474 2 11.999 2C13.5578 2 14.8161 3.34 14.8161 5V9.17988Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "red-line",
    d: "M4.2125 3.96999C3.8225 3.57999 3.8225 2.94999 4.2125 2.55999C4.6025 2.16999 5.2325 2.16999 5.6225 2.55999L20.9525 17.9C21.3425 18.29 21.3425 18.92 20.9525 19.31C20.5625 19.7 19.9325 19.7 19.5425 19.31L4.2125 3.96999Z",
    fill: "#DD5068"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/mic-off.8662a4ed351c4bb2e541a341f664f3f2.svg";
export { ForwardRef as ReactComponent };